import { useSingleEtfMarketReactionLines } from './hooks/useSingleEtfMarketReactionLines';
import { MarketCatalystReactionChartView } from './MarketCatalystReactionChartView';
import { MarketCatalystReactionProps } from './market-catalyst-reaction.types';

export const SingleEtfMarketCatalystReaction = ({
  tags,
  tickers,
  createdAt,
  themeId,
  leftHeaderNode,
}: MarketCatalystReactionProps) => {
  const { lines, fromDateEST, toDateEST, isLoading } =
    useSingleEtfMarketReactionLines({ tags, tickers, createdAt, themeId });

  return (
    <MarketCatalystReactionChartView
      isLoading={isLoading}
      fromDateEST={fromDateEST}
      toDateEST={toDateEST}
      lines={lines}
      leftHeaderNode={leftHeaderNode}
    />
  );
};
